import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PortfolioRoutingModule } from './portfolio-routing.module';
import { NewPortfolioComponent } from 'src/app/pages/new-portfolio/new-portfolio.component';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { TooltipButtonModule } from 'src/app/shared/tooltip-button/tooltip-button.module';
import { DevelopmentChartModule } from 'src/app/shared/charts/development-chart/development-chart.module';
import { InstrumentChartDropdownModule } from 'src/app/shared/charts/instrument-chart-card/instrument-chart-dropdown/instrument-chart-dropdown.module';
import { InstrumentChartCarouselModule } from 'src/app/shared/charts/instrument-chart-carousel/instrument-chart-carousel.module';
import { DropdownListModule } from 'src/app/shared/dropdown-list/dropdown-list.module';
import { TextInputModule } from 'src/app/shared/text-input/text-input.module';
import { SliderInputModule } from 'src/app/shared/slider-input/slider-input.module';
import { PlusMinusInputModule } from 'src/app/shared/plus-minus-input/plus-minus-input.module';
import { RadioInputGroupModule } from 'src/app/shared/radio-input-group/radio-input-group.module';
import { DipPickerModule } from 'src/app/shared/dip-picker/dip-picker.module';
import { VideoPreviewModule } from 'src/app/shared/video-preview/video-preview.module';
import { EntryFeeCalcModule } from 'src/app/shared/entry-fee-calc/entry-fee-calc.component.module';


@NgModule({
  declarations: [
    NewPortfolioComponent,
  ],
  imports: [
    CommonModule,
    PortfolioRoutingModule,
    AngularSvgIconModule,
    TranslateModule,
    ButtonModule,
    PreloadSpinnerModule,
    TooltipButtonModule,
    InstrumentChartDropdownModule,
    DevelopmentChartModule,
    InstrumentChartCarouselModule,
    DropdownListModule,
    TextInputModule,
    SliderInputModule,
    PlusMinusInputModule,
    RadioInputGroupModule,
    DipPickerModule,
    VideoPreviewModule,
    EntryFeeCalcModule,
  ],
  exports: [
    NewPortfolioComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class PortfolioModule { }
